export const backupMaintenanceMessages = {
  en: {
    pageTitle: 'System settings',
    backup: {
      boxTitle: 'Schedule system backup',
      enabled: 'Backup job is enabled',
      disabled: 'Backup job is disabled',
      type: 'Destination',
      server: 'Server',
      username: 'Username',
      password: 'Password',
      directory: 'Directory',
      btnSave: 'Save',
      days: 'days',
      validation: {
        required: 'This field is required',
        incorrectValue: 'The value is incorrect',
        absolutePath:
          'This field can\'t start with "/", only relative directory path is allowed',
      },
    },
    maintenance: {
      enabled: 'Maintenance job is enabled',
      disabled: 'Maintenance job is disabled',
      boxTitle: 'Schedule System Maintenance',
      btnSave: 'Save',
      btnRunMaintenance: 'Start Maintenance',
      validation: {
        required: 'This field is required',
      },
    },
    btnCertificationAuthorities: 'Certificate authorities',
    clearDb: {
      btnClear: 'Clear DB',
    },
    clearDbConfirm: {
      header: 'Clear database',
      subHeader:
        'This action will clear database. (*Requires additional confirmation.)',
      btnConfirm: 'Clear Database',
      btnSecondaryConfirm: 'Cancel',
    },
    resetSettingsConfirm: {
      header: 'Clear database confirmation',
      subHeader: (
        <>
          Data will be{' '}
          <span className='text-red-600'>permanently deleted.</span> Do you want
          to keep settings?
        </>
      ),
      btnConfirm: 'Keep settings',
      btnSecondaryConfirm: 'Reset Settings',
    },
  },
};
